import { capitalize } from "lodash";

export function filterSlotComps(slots, type) {
  if (!slots[type]) return [];
  return slots[type]
    .filter((vnode) => {
      return (
        vnode.componentInstance &&
        typeof vnode.componentInstance["is" + capitalize(type)] ===
          "function" &&
        vnode.componentInstance["is" + capitalize(type)]()
      );
    })
    .map((vnode) => vnode.componentInstance);
}

export function positionValidator(value) {
  return "x" in value && "y" in value && "z" in value;
}
